import { withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "space-y-3" }
const _hoisted_2 = { class: "flex items-end gap-3" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-wrap gap-2"
}
const _hoisted_4 = ["aria-label", "onClick"]

import { XMarkIcon } from '@heroicons/vue/20/solid'
import { ref } from 'vue'

import InputField from '@/components/neue/InputField.vue'
import WizardButton from '@/components/neue/wizard/WizardButton.vue'
import { parseZipCodes } from '@/helpers/zipCodes'


export default {
  __name: 'ZipCodeList',
  props: { modelValue: { type: Array, default: () => [] }, length: { type: Number, default: 5 } },
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const text = ref('')

const add = () => {
  const zips = parseZipCodes(text.value, props.length, props.modelValue)
  if (zips.length) emit('update:modelValue', [...props.modelValue, ...zips])
  text.value = ''
}

const remove = zip =>
  emit(
    'update:modelValue',
    props.modelValue.filter(z => z !== zip)
  )

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(InputField, {
        "model-value": text.value,
        placeholder: "Type or paste zip codes, separated by commas",
        class: "flex-1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (text.value = $event)),
        onKeydown: _withKeys(_withModifiers(add, ["stop","prevent"]), ["enter"])
      }, null, 8, ["model-value", "onKeydown"]),
      _createVNode(WizardButton, { onClick: add }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createTextVNode("+ Add", -1)
        ]))]),
        _: 1
      })
    ]),
    (__props.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.modelValue, (zip) => {
            return (_openBlock(), _createElementBlock("span", {
              key: zip,
              class: "inline-flex items-center gap-1 rounded-full border border-gray-300 py-0.5 pl-2.5 pr-1 text-sm text-gray-900"
            }, [
              _createTextVNode(_toDisplayString(zip) + " ", 1),
              _createElementVNode("button", {
                type: "button",
                class: "rounded-full p-0.5 text-gray-400 hover:text-gray-700",
                "aria-label": `Remove ${zip}`,
                onClick: $event => (remove(zip))
              }, [
                _createVNode(_unref(XMarkIcon), { class: "h-4 w-4" })
              ], 8, _hoisted_4)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

}